import { ProtocolContentData } from "../../protocol";
export default class SafetyAndSecurityRound extends ProtocolContentData {
    freeText;
    marSecLevel;
    constructor(freeText, marSecLevel) {
        super();
        this.freeText = freeText;
        this.marSecLevel = marSecLevel;
    }
}
//# sourceMappingURL=SafetyAndSecurityRound.js.map